angular.module('CarsSaraBo').factory('requestInterceptor', ['$q', '$rootScope', '$location', '$window', function ($q, $rootScope, $location, $window) {
    return {
        request: function (config) {
            var url = config.url;

            /*if($rootScope.session == null && $location.path != LOGIN_PATH) {
             !$location.path(LOGIN_PATH);
             }*/

            if (url.indexOf('/rest/') > 0 && $rootScope.lang) {

                if (url.indexOf('?') > 0) {
                    url = url + '&lang=' + $rootScope.lang.name;
                } else {
                    url = url + '?lang=' + $rootScope.lang.name;
                }
                config.url = url;
            }
            return config || $q.when(config);
        },

        requestError: function (rejection) {
            return $q.reject(rejection);
        },

        response: function (response) {
            return response || $q.when(response);
        },

        responseError: function (rejection) {
            if (rejection.status == 400) {
                if (!$rootScope.ignoreGlobalHttpErrorHandling) {
                    if (rejection.data && rejection.data.params) {
                        $rootScope.notifyErrorByCodeWithParams(rejection.data.message, rejection.data.params);
                    } else {
                        $rootScope.notifyErrorDetailByCodes(rejection);
                    }
                }
            } else if (rejection.status == 401) {
                $window.location.url = "../login-atp3";

                $rootScope.hideProgressBar();
            } else if (rejection.status == 403) {
                $location.path("/error");
            } else if (rejection.status == 404) {
                $rootScope.resourceNotFound(rejection.data);
            } else if (rejection.status == 500) {
                $location.path("/internal-error");
			}

            return $q.reject(rejection);
        }
    }
}])


//////////////////
// WEBPACK FOOTER
// ./public/app/models/interceptors/request_interceptor.js
// module id = 870
// module chunks = 3